<template>
  <div class="card green">
    <div class="content">
      <div class="header">
        {{ $t('HOTKEY') }}
        <i class="right floated keyboard icon"></i>
      </div>
      <div
        class="meta"
        v-html="
          $t('HOTKEY_META', {
            keys: ld.join(ld.map(trigger.configuration.keys, k => `<kbd>${k}</kbd>`), ''),
            modifiers: ld.join(ld.map(trigger.configuration.modifiers, k => `<kbd>${k}</kbd>`), '')
          })
        "
      ></div>
    </div>
    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>
      <div class="field">
        <typeahead
          :multiple="true"
          :max-items="100"
          :items="availableModifiers"
          :current-items="currentModifiers"
          :label-text="$tc('HOTKEY_MODIFIER', 1)"
          :placeholder-text="$tc('HOTKEY_MODIFIER', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('HOTKEY_MODIFIER', 1) })"
          :select-handler="addModifier"
          :remove-handler="removeModifier"
        >
          <template slot="selected" slot-scope="props">
            <span class="detail">{{ props.item.value }}</span>
          </template>
        </typeahead>
      </div>
      <div class="field">
        <typeahead
          :multiple="true"
          :max-items="100"
          :items="availableKeys"
          :current-items="currentKeys"
          :label-text="$tc('HOTKEY_KEY', 1)"
          :placeholder-text="$tc('HOTKEY_KEY', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('HOTKEY_KEY', 1) })"
          :select-handler="addKey"
          :remove-handler="removeKey"
        >
          <template slot="selected" slot-scope="props">
            <span class="detail">{{ props.item.value }}</span>
          </template>
        </typeahead>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Hotkey, Flow } from 'services'
import { Typeahead, Typenames } from 'ui'
import { map } from 'rxjs/operators'
import { ActionTypes } from 'store'

export default {
  name: 'hotkeytrigger',
  components: { Typeahead },

  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            keys: [],
            modifiers: []
          }
        }
      }
    }
  },

  data() {
    return {
      ld: _,
      availableModifiers: Hotkey.modifiers,
      availableKeys: Hotkey.keys,
      errorMessage: null
    }
  },

  computed: {
    allFlows() {
      return this.$store.state.flow.items
    },
    currentModifiers() {
      return this.trigger && this.trigger.configuration
        ? _.map(this.trigger.configuration.modifiers, m => {
            return { id: m, name: m, value: m }
          })
        : []
    },
    currentKeys() {
      return this.trigger && this.trigger.configuration
        ? _.map(this.trigger.configuration.keys, k => {
            return { id: k, name: k, value: k }
          })
        : []
    }
  },

  methods: {
    updateErrorMessage() {
      const usedForFlow = this.findFlowWithHotkey(
        this.trigger.configuration.modifiers,
        this.trigger.configuration.keys
      )
      if (usedForFlow) {
        this.errorMessage = this.$i18n.t('USED_IN', { thing: usedForFlow.name })
        return
      } else {
        this.errorMessage = null
      }
    },

    addModifier(item) {
      this.trigger.configuration.modifiers.push(item.value)
      this.updateErrorMessage()
    },

    removeModifier(item) {
      Vue.set(
        this.trigger.configuration,
        'modifiers',
        _.filter(this.trigger.configuration.modifiers, m => m !== item.value)
      )
      this.updateErrorMessage()
    },

    addKey(item) {
      this.trigger.configuration.keys.push(item.value)
      this.updateErrorMessage()
    },

    removeKey(item) {
      Vue.set(
        this.trigger.configuration,
        'keys',
        _.filter(this.trigger.configuration.keys, x => x != item.value)
      )
      this.updateConfiguration()
    },

    findFlowWithHotkey(mods, keys) {
      return _.find(this.allFlows, f => {
        const triggers =
          f.typeConfig &&
          f.typeConfig.triggers &&
          f.typeConfig.triggers.external &&
          f.typeConfig.triggers.external
        return _.find(triggers, t => {
          return (
            t.configuration &&
            _.isEqual(t.configuration.modifiers, mods) &&
            _.isEqual(t.configuration.keys, keys)
          )
        })
      })
    }
  },

  created() {
    Flow.readAllFlows()
  }
}
</script>
